export default __webpack_public_path__ + "static/media/Black.af2700b5.png";